import { createSlice } from '@reduxjs/toolkit';
import { CiuAllocationsState } from './types';

const initialState: CiuAllocationsState = {
  configurationSections: null,
  formSections: null,
  selectedConfigurationId: null,
  editConfigurationData: null,
  allocationStats: null,
  isDrawerLoading: false,
  isTableLoading: false,
  isStatsLoading: false,
  error: null,
  pagination: {
    pageIndex: 0,
    pageSize: 10,
    totalElements: 0
  }
};

const ciuAllocationsSlice = createSlice({
  name: 'ciuAllocations',
  initialState,
  reducers: {
    setConfigurationSections: (state, action) => {
      state.configurationSections = action.payload;
      state.error = null;
    },
    setFormSections: (state, action) => {
      state.formSections = action.payload;
      state.error = null;
    },
    setEditConfigurationData: (state, action) => {
      state.editConfigurationData = action.payload;
      state.error = null;
    },
    setSelectedConfigurationId: (state, action) => {
      state.selectedConfigurationId = action.payload;
    },
    setDrawerLoading: (state, action) => {
      state.isDrawerLoading = action.payload;
    },
    setTableLoading: (state, action) => {
      state.isTableLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination.pageIndex = action.payload.pageIndex;
      state.pagination.pageSize = action.payload.pageSize;
      state.pagination.totalElements = action.payload.totalElements;
    },
    setAllocationStats: (state, action) => {
      state.allocationStats = action.payload;
    },
    setStatsLoading: (state, action) => {
      state.isStatsLoading = action.payload;
    }
  }
});

export const {
  setConfigurationSections,
  setFormSections,
  setEditConfigurationData,
  setSelectedConfigurationId,
  setDrawerLoading,
  setTableLoading,
  setError,
  setPagination,
  setAllocationStats,
  setStatsLoading
} = ciuAllocationsSlice.actions;

export default ciuAllocationsSlice.reducer;
